<nav class="main-nav">
  <div class="nav-container">
    <div class="hamburger-menu" [class.open]="isMenuOpen" (click)="toggleMenu()">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="logo">
      <img src="https://res.cloudinary.com/tatikka/image/upload/v1768912741/LOGO-porto_kvijsd.png"
        alt="Porto Bank Consórcio" width="88" height="20.25">
    </div>
    <ul class="nav-links" [class.active]="isMenuOpen">
      <li *ngIf="!isVeiculosPage()"><a routerLink="/veiculos-2" routerLinkActive="active" (click)="closeMenu()">Consórcio
          de Veículos</a></li>
      <li *ngIf="!isImoveisPage()"><a routerLink="/imoveis-2" routerLinkActive="active" (click)="closeMenu()">Consórcio de
          Imóveis</a></li>
      <li><a href="#simulacao" (click)="$event.preventDefault(); scrollToSection('simulacao'); closeMenu()" style="cursor: pointer;">Simulação</a></li>
      <li><a href="#como-funciona" (click)="$event.preventDefault(); scrollToSection('como-funciona'); closeMenu()" style="cursor: pointer;">Como Funciona</a></li>
      <li><a href="#vantagens" (click)="$event.preventDefault(); scrollToSection('vantagens'); closeMenu()" style="cursor: pointer;">Vantagens</a></li>
      <li><a href="#contato" (click)="$event.preventDefault(); scrollToSection('contato'); closeMenu()" style="cursor: pointer;">Contato</a></li>
    </ul>
    <div class="logo-Niadcon">
      <img src="https://res.cloudinary.com/tatikka/image/upload/v1768912741/Logo-Niadcon-Consorcios_yws26q.png"
        alt="Niadcon Consórcios" width="126" height="45">
    </div>
  </div>
</nav>

<!-- Secondary Navigation Bar -->
<div class="secondary-nav">
  <div class="nav-container">
    <div class="breadcrumb">
      <span class="breadcrumb-home">Consórcio</span>
      <span class="breadcrumb-separator">/</span>
      <span class="breadcrumb-current">Consórcio de {{ getCurrentPageName() }}</span>
    </div>
    <button class="btn-whatsapp" (click)="onWhatsAppClick()">
      <img src="https://res.cloudinary.com/tatikka/image/upload/f_webp/v1768858403/ICON-WhatsApp_qrj6rt.png"
        alt="WhatsApp" class="whatsapp-icon" width="24" height="24">
      <span>Falar com um Consultor</span>
    </button>
  </div>
</div>